import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import "./CustomcssMain.css";
import "../../loader.css";
import { set } from "lodash";

function ManagerPatientList(props) {
  const [PatientList, setPatientList] = useState([]);
  const navigate = useHistory();
  const mangerId = localStorage.getItem("ManegerId");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    LoadPatient();
  }, []);

  const LoadPatient = () => {
    // axios.get(`${process.env.REACT_APP_API_URL}/GetAllPatient`)
    //     .then(res => {
    //         //console.log("list", res.data)
    //         setPatientList(res.data)
    //     })
    const datavalue = {
      UsId: mangerId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetAllPortalPatient`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions)
      // axios.post(`https://localhost:7261/getIntentsByid`, datavalue, config)
      .then((res) => {
        //console.log("list", res.data)
        setPatientList(res.data);
        setIsLoading(false);
      });
  };
  // ShowIntents
  const ShowIntents = (pid, pName, pGender) => {
    localStorage.setItem("PatQusId", pid);
    localStorage.setItem("PatName", pName);
    // localStorage.setItem('Backvalue',backval)
    localStorage.removeItem("Backvalue");
    localStorage.setItem("PatGender", pGender);

    //console.log("the vaue", pid)

    const datavalue = {
      id: pid,
      key: "Not",
    };

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/getIntentsByPid`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      // //console.log("list", res.data)

      //console.log("lecngth", res.data.length)

      localStorage.setItem("QuestionLength", res.data.length);

      res.data.length > 10
        ? navigate.push("/PtientIntentList")
        : navigate.push("/PtientCusIntentList");
      // setIntentList(res.data)
    });
  };
  const EditPatient = (valid) => {
    localStorage.setItem("PatientId", valid);
  };

  const InsertQues = (valid, pName, backval) => {
    localStorage.setItem("PatQusId", valid);
    localStorage.setItem("PatName", pName);
    localStorage.setItem("BackQues", backval);

    //console.log("the vaue", valid)

    const datavalue = {
      id: valid,
      key: "Not",
    };

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/getIntentsByPid`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      // //console.log("list", res.data)

      //console.log("lecngth", res.data.length)

      localStorage.setItem("QuestionLength", res.data.length);

      // res.data.length > 10 ? navigate.push('/PtientIntentList') :  navigate.push('/PtientCusIntentList')
      // setIntentList(res.data)
    });
  };

  const deletePatient = (value) => {
    //console.log("the vaue", value)

    // Extract token from localStorage.state
            let token = null;
            try {
                const raw = localStorage.getItem("state");
                if (raw) {
                    const state = JSON.parse(raw);
                    token = state.auth?.token;
                }
            } catch (e) {
                console.error("Token parsing failed", e);
            }

    const datavalue = {
      pId: value,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/DeletePatient`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
    };
    axios(authOptions)
      // axios.post(`https://localhost:7261/DeleteIntents`, datavalue, config)
      .then((res) => {
        //console.log("get value", res);

        //console.log("success")

        // setName({ intents: "", Ans1: "", Ans2: "" });
        Swal.fire({
          title: "Success",
          text: "Deleted successfully",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(function () {
          // window.location.href = "/patient-ai/IntentList";
          // history.push('/patient-ai/IntentList');
          // navigate.push('/PatientList');
          window.location.reload(true);
        });
      })
      .catch((error) => {
        //console.log("error occur", error);
      });
  };
  const BackFunc = () => {
    navigate.push("/index");
  };

  return (
    <>
      <div className="page-content-wrapper">
      {isLoading ? (
          <div className="page-content d-flex justify-content-center align-items-center">
          <div className="my-wrapper">
          <div class="spinner center">
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
        </div>
          </div>
        
        </div>
        ) : (
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title my-0">List of Cases</div>
              </div>
            </div>
            <div className="page-title-breadcrumb">
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn d-inline-block"
                  style={{backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38"}}
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-head">
                      {/* <header>Patient List</header> */}
                      <div className="tools">
                        {/* <a className="fa fa-repeat btn-color box-refresh" href="javascript:;"></a>
                                                <a className="t-collapse btn-color fa fa-chevron-down"
                                                    href="javascript:;"></a>
                                                <a className="t-close btn-color fa fa-times" href="javascript:;"></a> */}
                      </div>
                    </div>
                    <div className="card-body ">
                      <div className="table-responsive">
                        <table className="table table-striped custom-table table-hover">
                          <thead>
                            <tr>
                              <th>Case ID</th>
                              <th width="30%"> Name</th>
                              <th width="20%">Gender</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {PatientList &&
                              PatientList.length > 0 &&
                              PatientList.map((item) => (
                                <tr>
                                  <td className="text-left">{item.p_id}</td>
                                  <td>
                                    <Link
                                      to="/LUpdatePatient"
                                      onClick={() => EditPatient(item.id)}
                                      className=""
                                    >
                                      <a href="#">{item.patient_Nm}</a>
                                    </Link>
                                  </td>
                                  <td className="text-left">{item.p_Gender}</td>

                                  <td>
                                    <Link
                                      to="/LUpdatePatient"
                                      onClick={() => EditPatient(item.id)}
                                      className="btn btn-xs py-2"
                                      style={{backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38"}}
                                    >
                                      <i className="fa fa-pencil"></i>
                                    </Link>
                                    <button
                                      className="btn btn-danger btn-xs py-2"
                                      onClick={() => {
                                        Swal.fire({
                                          title: "Are you sure?",
                                          text: "You won't be able to revert this!",
                                          icon: "warning",
                                          showCancelButton: true,
                                          confirmButtonColor: "#6777ef",
                                          cancelButtonColor: "#d33",
                                          confirmButtonText: "Yes, delete it!",
                                        }).then((result) => {
                                          if (result.isConfirmed) {
                                            deletePatient(item.id);
                                          }
                                        });
                                      }}
                                    >
                                      <i className="fa fa-trash-o "></i>
                                    </button>

                                    {/* <Link
                                      to="/PatientQues"
                                      onClick={() =>
                                        InsertQues(
                                          item.p_id,
                                          item.patient_Nm,
                                          "directQues"
                                        )
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary py-2 px-3"
                                      >
                                        Add Question
                                      </button>
                                    </Link> */}
                                    {/* <i data-feather="file-plus"></i> */}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        )
      }
      </div>
    </>
  );
}

export default ManagerPatientList;
